
// TODO
export const ErrorNotFound = () => {
    return <div>
        404
    </div>
}

